module.exports = __webpack_public_path__ + "static/media/NEXTCanada.c008c4a9.png";